export default class Slider {
  
  constructor() {
    this.boxesSlider = document.querySelector('.boxes-slider');
    this.cardSlider = document.querySelector('.card-slider');
    this.careersSlider = document.querySelector('.careers-slider');
    this.cardSliderInitialized = false;
    
    this.initSliders();
    this.addResizeListener();
  }
  
  initSliders() {
    if (this.boxesSlider) {
      this.initBoxesSlider();
    }
    if (this.cardSlider) {
      this.initCardSlider();
    }
    if (this.careersSlider) {
      this.initCareersSlider();
    }
  }
  
  initBoxesSlider() {
    // Destroy existing slider if it exists
    if ($(this.boxesSlider).hasClass('slick-initialized')) {
      $(this.boxesSlider).slick('unslick');
    }
    
    $(this.boxesSlider).slick({
      arrows: false,
      autoplay: 0,
      slidesToShow: 6,
      responsive: [
        {
          breakpoint: 1399,
          settings: {
            slidesToShow: 5
          }
        }, {
          breakpoint: 991,
          settings: {
            slidesToShow: 4
          }
        }, {
          breakpoint: 767,
          settings: {
            slidesToShow: 3
          }
        }, {
          breakpoint: 575,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
    
    $(this.boxesSlider).find('div').each(function() {
      $(this).attr('tabindex', '-1');
    });
    
    // Remove existing event listeners and add new ones
    $('.boxes-slider-prev').off('click.boxesSlider').on('click.boxesSlider', () => {
      $(this.boxesSlider).slick('slickPrev');
    });
    
    $('.boxes-slider-next').off('click.boxesSlider').on('click.boxesSlider', () => {
      $(this.boxesSlider).slick('slickNext');
    });
  }
  
  initCardSlider() {
    const shouldInitialize = window.innerWidth <= 991;
    
    if (shouldInitialize && !this.cardSliderInitialized) {
      // Initialize slider for mobile
      $(this.cardSlider).slick({
        arrows: false,
        autoplay: 0,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2
            }
          }, {
            breakpoint: 576,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
      
      $(this.cardSlider).find('div').each(function() {
        $(this).attr('tabindex', '-1');
      });
      
      // Remove existing event listeners and add new ones
      $('.card-slider-prev').off('click.cardSlider').on('click.cardSlider', () => {
        $(this.cardSlider).slick('slickPrev');
      });
      
      $('.card-slider-next').off('click.cardSlider').on('click.cardSlider', () => {
        $(this.cardSlider).slick('slickNext');
      });
      
      this.cardSliderInitialized = true;
      
    } else if (!shouldInitialize && this.cardSliderInitialized) {
      // Destroy slider for desktop
      if ($(this.cardSlider).hasClass('slick-initialized')) {
        $(this.cardSlider).slick('unslick');
      }
      
      // Remove event listeners
      $('.card-slider-prev').off('click.cardSlider');
      $('.card-slider-next').off('click.cardSlider');
      
      // Remove tabindex attributes
      $(this.cardSlider).find('div').each(function() {
        $(this).removeAttr('tabindex');
      });
      
      this.cardSliderInitialized = false;
    }
  }
  
  initCareersSlider() {
    // Destroy existing slider if it exists
    if ($(this.careersSlider).hasClass('slick-initialized')) {
      $(this.careersSlider).slick('unslick');
    }
    
    $(this.careersSlider).slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: 0,
      arrow: true,
      dots: true,
      responsive: [{
        breakpoint: 600,
        settings: {
          dots: false,
        }
      }]
    });
  }
  
  addResizeListener() {
    window.addEventListener('resize', () => {
      // Debounce resize events
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        // Only reinitialize card slider on resize since it's the only one with conditional logic
        if (this.cardSlider) {
          this.initCardSlider();
        }
      }, 250);
    });
  }
}